import { render, staticRenderFns } from "./BonDePassageModal.vue?vue&type=template&id=2fde89dd"
import script from "./BonDePassageModal.vue?vue&type=script&lang=ts"
export * from "./BonDePassageModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports